module.exports = __webpack_public_path__ + "static/media/delivery-moped-retro-svgrepo-com.33b109c1.svg";